import SearchInput from "@/components/SearchInput/SearchInput";
import { useCase } from "@/features/case/use-case";
import {
  useSearchCreditorTabListDataQuery,
} from "@/services/creditors/creditorsReducers";
import {
  MotifErrorMessage,
  MotifFormField,
  MotifLabel,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const SearchCreditor = ({
  handleChange,
  creditorData,
  resolvedStatus,
  setSelectedAssigneeId,
}: any) => {
  const caseData = useCase();
  const { t } = useTranslation();
  const [searchData, setSearchData] = useState<any>({
    CaseId: caseData.caseId,
    PageNumber: 1,
    PageSize: 100,
    SearchText: creditorData?.claimAssignee?.assigneeName || "",
  });
  
  const [value, setValue] = useState("");

  const {
    isLoading,
    isFetching: quickSearchDataFetching,
    data,
    error: searchError,
  } = useSearchCreditorTabListDataQuery(searchData)
  const [creditorNames, setCreditorNames] = useState([]);
  useEffect(() => {
    if (data && data.results) {
      let names = data?.results?.map(
        (items: { creditorName: string; creditorReference: any }) =>
          `${items?.creditorName || ""} | ${items?.creditorReference || ""}`
      );
      setCreditorNames(names);
    }
  }, [data]);
  useEffect(() => {
    if(creditorData?.claimAssignee?.assigneeName){
      setValue(`${creditorData?.claimAssignee?.assigneeName?.trim() || ""} | ${creditorData?.claimAssignee?.assigneeReference || ""}`);
    }
  }, [creditorData]);
  function getCreditorId(props: any) {
    setValue(props);
    const creditorID = data?.results?.filter(
      (items: { creditorName: string; creditorReference: any }) => {
        if (`${items?.creditorName || ""} | ${items?.creditorReference || ""}` === props)
          return true;
        else return false;
      }
    );
    handleChange(
      "defaultAssigneeId",
      creditorID[0] && creditorID[0]?.creditorId
    );
    setSelectedAssigneeId(creditorID[0] && creditorID[0]?.creditorId);
  }
  return (
    <div>
      {isLoading ? (
        <MotifProgressLoader variant="circular" size="xs" />
      ) : (
        <>
          <MotifFormField>
            <SearchInput
              aria-label="Search"
              id="states-search"
              items={creditorNames}
              onBlur={function Ua() {}}
              onChange={(e: any) => {
                setSelectedAssigneeId("")
                let enterdvalue = e?.target?.value
                if(enterdvalue?.includes(" | ")){
                  enterdvalue = e?.target?.value
                  ?.split(" | ")[0]
                  ?.trimStart();
                  enterdvalue =`${enterdvalue} `
                }
                  setCreditorNames([]);
                  setSearchData({ ...searchData, SearchText: enterdvalue })
                setValue(enterdvalue);
              }}
              onClear={() => {}}
              onClose={function Ua() {}}
              // onEnter={() => {
              //   // setCreditorNames([]);
              //   // setSearchData({ ...searchData, SearchText: value });
              // }}
              onFocus={function Ua() {}}
              onOpen={function Ua() {}}
              open={!quickSearchDataFetching}
              onSelect={(e: any) => getCreditorId(e)}
              placeholder="Search for..."
              value={value}
              disabled={resolvedStatus}
              withOutDebounce={false}
            />
          </MotifFormField>
          {quickSearchDataFetching && (
            <MotifLabel>
              {t("global.globalNotifications.loadingMessage")}
            </MotifLabel>
          )}
          {data?.results?.length === 0 &&
            !searchError &&
            !quickSearchDataFetching && (
              <MotifErrorMessage>
                {t("global.globalNotifications.noRecords")}
              </MotifErrorMessage>
            )}
          {searchError && !quickSearchDataFetching && (
            <MotifErrorMessage>
              {t("global.globalNotifications.wentWrong")}
            </MotifErrorMessage>
          )}
        </>
      )}
    </div>
  );
};
